<template>
  <app-alert
    :heading="heading"
    color="warning"
    icon="alert-circle"
  >
    <p>{{ messageOverride || message }}</p>
  </app-alert>
</template>

<script setup>
import { computed } from 'vue';
import AppAlert from '@/components/ui/Alert.vue';

const props = defineProps({
  invoiceProvider: {
    type: String,
    required: true,
  },
  isAgency: {
    type: Boolean,
    default: false,
  },
  messageOverride: {
    type: String,
  },
});

const heading = computed(() =>
  props.isAgency ? `Invoicing managed through ${props.invoiceProvider}.` : 'Looking for invoices?'
);

const message = computed(() =>
  props.isAgency
    ? `To switch your invoicing back to Sion, please reach out to info@sioncentral.com.`
    : `Invoice downloads aren't available here because this agency uses ${props.invoiceProvider} for invoicing. Please contact the agency directly to request an invoice for this transfer.`
);
</script>
